<template>
  <pt-integral-particulars @membersPointsDetailsExport="membersPointsDetailsExport" class="pt-integral-particulars__withData"></pt-integral-particulars>
</template>

<script>
import PtIntegralParticulars from './index'
export default {
  name: 'pt-integral-particulars__withData',
  components: {
    'pt-integral-particulars': PtIntegralParticulars
  },
  data () {
    return {
      exportLoading: false
    }
  },
  methods: {
    membersPointsDetailsExport (val) {
      this.exportLoading = true
      this.$store.dispatch('membersPointsDetailsExport', val).then(res => {
        this.exportLoading = false
        this.$message.success('数据准备中，完成导出后我们会将数据保存在“导出历史”中，您稍后下载即可')
      }).catch(err => {
        this.exportLoading = false
        this.$message.error(err || '导出订金结算失败')
      })
    }
  }
}
</script>
